import { render, staticRenderFns } from "./ManageTagsModal.vue?vue&type=template&id=989dec3c&scoped=true"
import script from "./ManageTagsModal.vue?vue&type=script&lang=js"
export * from "./ManageTagsModal.vue?vue&type=script&lang=js"
import style0 from "./ManageTagsModal.vue?vue&type=style&index=0&id=989dec3c&prod&scoped=true&lang=css"
import style1 from "./ManageTagsModal.vue?vue&type=style&index=1&id=989dec3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989dec3c",
  null
  
)

export default component.exports